import { useCallback, useSyncExternalStore } from "react";
import { unloadApplication } from "single-spa";
import {
  getLocalServersSnapshot,
  setSelectedMachineId,
  subscribeLocalServers,
} from "@/shared/localServers";

const AKVA_SCANNER_APP = "@observe/akva-network-scanner";

// Subscribes to the local-server store the React-blessed way and owns the
// selection side effect (MFE remount) so the picker is just a dropdown. The list
// itself follows the store for the page's lifetime — see trackLocalServers.
export function useLocalServers() {
  const { servers, selectedMachineId } = useSyncExternalStore(
    subscribeLocalServers,
    getLocalServersSnapshot,
  );

  const select = useCallback((id: number | null) => {
    setSelectedMachineId(id);
    // Remount the MFE so customProps re-resolve with the new IP. The store
    // already updated the backend URL the MFE reads as a cross-bundle fallback.
    void unloadApplication(AKVA_SCANNER_APP).catch(() => {
      /* app not loaded yet — first mount will read the selection */
    });
  }, []);

  return { servers, selectedMachineId, select };
}
